import { rankingData } from '@/mocks/homeData';

function getRankColor(rank: number): string {
  if (rank === 1) return 'bg-accent-500 text-background-50';
  if (rank === 2) return 'bg-secondary-500 text-background-50';
  if (rank === 3) return 'bg-primary-500 text-background-50';
  return 'bg-background-200 text-foreground-600';
}

function getTrendIcon(trend: string) {
  if (trend === 'up') return 'ri-arrow-up-line text-primary-500';
  if (trend === 'down') return 'ri-arrow-down-line text-foreground-400';
  return 'ri-subtract-line text-foreground-400';
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时热度 · 追剧风向标</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-100 rounded-2xl border border-background-200 overflow-hidden">
          {rankingData.map((item, index) => (
            <div
              key={index}
              className={`flex items-center gap-4 px-4 md:px-6 py-4 cursor-pointer hover:bg-background-200/50 transition-colors ${
                index < rankingData.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${getRankColor(item.rank)}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <i className={`${getTrendIcon(item.trend)} text-sm`}></i>
                <span className="text-sm font-semibold text-accent-500">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}